import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { environment } from 'environments/environment';
import { FileUpload } from '../file-upload/file-upload';
import { first } from 'rxjs/operators';
import { Validations } from 'utility/validators';
import { NotificationService } from '../notification.service';
import { FileUploadService } from './file-upload.service';

@Component({
  selector: 'ngx-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  public validations = Validations;
  public FileGroupList: any;
  fileslist: any;
  a_parentid: any;
  public startdate: Date = new Date();
  public enddate: Date = new Date();
  public format = 'dd-MM-yyyy';
  @ViewChild('file') myInputVariable: ElementRef;
  public docuploadForm: FormGroup = new FormGroup({
    id: new FormControl(),
    filegroup: new FormControl('', [Validations.isRequired()]),
    parentid: new FormControl(''),
    validfrom: new FormControl(new Date()),
    validupto: new FormControl(new Date()),
    remarks: new FormControl('', [Validators.maxLength(250), Validators.minLength(2)]),
    documentreminder: new FormControl(1),
    uom: new FormControl(''),
    filename: new FormControl(),
    documentid: new FormControl(''),
  });
  listuom: any;
  flagSize: boolean;
  public decimals = 0;
  constructor(private fileUploadService: FileUploadService, private http: HttpClient, private notifyService: NotificationService) { }
  @Input() public IsViewDoc = false;
  @Input() public IsReminder = true;
  @Input() public FileGroup = false;
  @Input() public Renew;
  @Input() public IsViewPage = false;
  @Input() public set model(model: FileUpload) {
    this.docuploadForm.reset(model);
    this.a_parentid = model.parentid;
    this.GetFilesfromParentId(model.parentid);
    if (this.IsViewDoc == true) {
      this.docuploadForm.controls['documentid'].setValidators([Validations.isRequired(), Validators.maxLength(30), Validators.minLength(1), Validations.trimedSpaces]);
    } else {
      this.docuploadForm.controls['validfrom'].clearValidators();
      this.docuploadForm.controls['validupto'].clearValidators();
      this.docuploadForm.controls['documentid'].clearValidators();
      this.docuploadForm.controls['documentreminder'].clearValidators();
      this.docuploadForm.controls['uom'].clearValidators();
    }
  }
  public OnKeyUP(event) {
    if (event.target.value == "")
      event.target.value = "";
  }
  ngOnInit() {
    this.fileUploadService.GetFileGroups(this.FileGroup).pipe(first()).subscribe(result => { this.FileGroupList = result; });
    this.fileUploadService.GetDocumentUOM().pipe(first()).subscribe(result => { this.listuom = result; this.docuploadForm.controls.uom.setValue(this.listuom[0].value);});    
    if (this.IsViewDoc == true) {
      this.docuploadForm.controls['documentid'].setValidators([Validations.isRequired(), Validators.maxLength(30), Validators.minLength(1), Validations.trimedSpaces]);
    } else {
      this.docuploadForm.controls['validfrom'].clearValidators();
      this.docuploadForm.controls['validupto'].clearValidators();
      this.docuploadForm.controls['documentid'].clearValidators();
      this.docuploadForm.controls['documentreminder'].clearValidators();
      this.docuploadForm.controls['uom'].clearValidators();
    }

    if (this.IsViewDoc == true && this.IsReminder == false) {
      this.docuploadForm.controls['documentreminder'].clearValidators();
      this.docuploadForm.controls['uom'].clearValidators();
      this.docuploadForm.controls['validfrom'].clearValidators();
      this.docuploadForm.controls['validupto'].clearValidators();
      this.docuploadForm.controls['documentid'].clearValidators();

    }
  }
  public filterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };
  public uploadFile = async (files) => {
    if (files.length === 0) { return; }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append("Renew", this.Renew);
    formData.append('file', fileToUpload, fileToUpload.name);
    if (this.IsViewDoc == true) {
      if (this.docuploadForm.value.validfrom != null) {
        var date = new Date(this.docuploadForm.value.validfrom);
        var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()))
        this.docuploadForm.value.validfrom = utcDate;
      }
      if (this.docuploadForm.value.validupto != null) {
        var update = new Date(this.docuploadForm.value.validupto);
        var uputcDate = new Date(Date.UTC(update.getFullYear(), update.getMonth(), update.getDate(), update.getHours(), update.getMinutes()))
        this.docuploadForm.value.validupto = uputcDate;
      }
      if (this.docuploadForm.value.uom == null) {
      }
    } else {
    }
    formData.append('attachment', JSON.stringify(this.docuploadForm.value));
    const t = await this.http.post<any>(`${environment.apiUrl}/FileManager/Upload?UserId=` + localStorage.getItem("UserId"), formData, { reportProgress: true, observe: 'events' }).toPromise();
    if (t != null) {
      this.notifyService.showSuccess("Document Uploaded Successfully", 'Success');
      this.myInputVariable.nativeElement.value = '';
      this.GetFilesfromParentId(this.docuploadForm.value.parentid);
      this.docuploadForm.reset();
      this.docuploadForm.patchValue({ parentid: this.a_parentid });
    }
  }
  public async GetFilesfromParentId(parentid: any) {  /// when data updated fetch
    const result = await this.fileUploadService.GetFilesfromParentId(parentid);
    this.fileslist = JSON.parse(result.data);
  }
  public download(filename: any) {
    this.fileUploadService.downloadFile(filename).subscribe(
      data => {
        switch (data.type) {
          case HttpEventType.Response:
            const downloadedFile = new Blob([data.body], { type: data.body.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = filename;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
        }
      },
      error => { }
    );
  }
  public deleteDocument(id: any, parentid: any) {
    var result = confirm("Are you sure you want to Delete this Document?");
    if (result) {
      this.fileUploadService.deleteDocument(id).pipe(first()).subscribe(result => {
        this.notifyService.showSuccess('Document Deleted Successfully', 'Deleted row');
        this.GetFilesfromParentId(parentid);
      })
    }

  }
  getFormattedDate(input: string) {
    const newdate = new Date(input);
    return (newdate.getMonth() + 1) + '-' + (newdate.getDate() + 1) + '-' +
      newdate.getFullYear() + ' ' + newdate.getHours() + ':' + newdate.getMinutes();
  }
  public onFromDateChange(value: Date): void {
    //this.enddate = value;
    this.enddate =  new Date(value.setDate(value.getDate() + 1));
  }
  public changestart(value) {
    const lastChar = value.slice(-1);
    if (lastChar == " " && value.length == 1) {
      this.docuploadForm.controls['documentid'].setErrors({ 'LastCharError': true });
    }
    this.fileUploadService.checkuniqueDocumentID(value).pipe(first()).subscribe(result => {
      if (result > 0)
        this.docuploadForm.controls['documentid'].setErrors({ 'uniquecheckerror': true });
      return true;
    });

  }
  public changeremark(value) {
    const lastChar = value.slice(-1);
    if (lastChar == " " && value.length == 1) {
      this.docuploadForm.controls['remarks'].setErrors({ 'LastCharError': true });
    }
  }
  onImageChangeFromFile($event: any) {
    if ($event.target.files && $event.target.files[0]) {
      let file = $event.target.files[0];
    debugger;
      if (file.size >= 5242880) {        
        this.notifyService.showWarning('Please upload file with size less than 5 MB', 'Warning');
       this.flagSize=false;       
      }
      else{
        this.flagSize=true;       

      }
    }
  }

}
